//
// locale_pt.js
// automatically generated by generateLocalePacks.js
//
import messages from '../../app/javascript/mastodon/locales/pt.json';
import localeData from "react-intl/locale-data/pt.js";
import { setLocale } from '../../app/javascript/mastodon/locales';
setLocale({messages, localeData});



// WEBPACK FOOTER //
// ./tmp/packs/locale_pt.js